<template>
<div class="DeviceListsGas">
  <div class="devcieContainer" :style="styleObject" v-if="JSON.stringify(tabData) == '{}'">
    <!-- <h4>设备列表</h4> -->
    <div class="treeAside">
      <div class="treeTop">
        <span class="treeTopTitle">区域</span>
      </div>
      <div class="treeBox">
        <el-tree
          lazy
          :load="loadData"
          :props="props"
          v-if="1"
          class="tree"
          ref="tree"
          :indent="6"
          node-key="value"
          highlight-current
          :expand-on-click-node="false"
          @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree>
      </div>
    </div>
    <div class="container">
      <div class="query">
        <div class="queryCons">
          <el-input class="common" placeholder="设备名称/设备类型/IMEI" autocomplete="off" v-model="searchText" style="width:200px;"></el-input>
          <el-select class="common" v-model="keyWords.isInstall" placeholder="是否安装" clearable>
            <el-option label="已安装" :value="1"></el-option>
            <el-option label="未安装" :value="0"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isRegist" placeholder="是否注册" clearable>
            <el-option label="已注册" :value="1"></el-option>
            <el-option label="未注册" :value="0"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isOnline" placeholder="是否在线" clearable>
            <el-option label="在线" :value="true"></el-option>
            <el-option label="离线" :value="false"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isAlarm" placeholder="是否报警" clearable>
            <el-option label="报警" :value="true"></el-option>
            <el-option label="未报警" :value="false"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isFault" placeholder="是否故障" clearable>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>

          <el-button
            class="common"
            type="primary"
            size="medium"
            @click="serachData"
            icon="el-icon-search">搜索</el-button>
          <!-- <el-button class="delSome" type="primary" size="medium" @click="changeRightCons" icon="el-icon-s-data">实时统计</el-button> -->
        </div>
      </div>
      <div class="listsContainer" :style="styleObjectCons">
        <!-- :class="changeStatus?'':'active'" -->
        <div class="listsLeft">
          <el-scrollbar wrap-class="scrollbar-wrapper" v-loading="tableLoading">
            <ul class="clearfix cardList">
              <li
                v-for="(dataInfo, index) in dataList"
                :key="index"
                @click="handleList(dataInfo.deviceId)"
                :class="dataInfo.isOnline == '离线' ? 'active' :dataInfo.isAlarm == '报警中' ? 'active1' :dataInfo.isFault == '故障' ? 'active2' : 'active3'">
                <h4>{{ dataInfo.name }} <i class="el-icon-edit-outline" @click.stop="handleEditClick(dataInfo)"></i></h4>
                <p>设备编码: <span>{{ dataInfo.imei }}</span></p>
                <p>传输方式: <span>国标</span></p>
                <p>传输协议: <span>TCP</span></p>
                <div class="status"> <span>{{ dataInfo.isOnline }}</span> </div>
                <p>详细地址: <span>{{ dataInfo.installLocation }}</span></p>
                <p>安装时间: <span>2025-05-04-12 14:00:14{{ dataInfo.installTime }}</span></p>
              </li>
            </ul>
          </el-scrollbar>
          <div class="noData" v-if="!(dataList&&dataList.length)&&consShow">
            <img src="../../assets/img/noData.png" alt="">
            <div class="tip">暂无数据</div>
          </div>
          <div class="cardPage">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.currentPage"
              :page-sizes="pagination.pageSizes"
              :page-size="pagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="maskingRight" v-if="changeStatus">
    <div class="listsRight" :class="showSlid?'component-slid-open' : 'component-slid-out'">
      <div class="messContainer">
        <div class="cons">
          <device-right-cons :typeId="1" @closeRightCons="closeRightCons"></device-right-cons>
        </div>
      </div>
    </div>
  </div>

  <div class="mainContent" :style="styleObject" v-if="JSON.stringify(tabData) != '{}'">
    <div class="navShow">
      <h3 v-if="JSON.stringify(tabData) == '{}'">用传列表</h3>
      <el-breadcrumb separator=">">
        <template v-if="JSON.stringify(tabData) != '{}'">
          <el-breadcrumb-item :to="{ path: '/deviceTransferList' }">
            <span @click="jumpDev">用传列表</span>
          </el-breadcrumb-item>
          <template>
            <el-breadcrumb-item>设备列表</el-breadcrumb-item>
          </template>
        </template>
      </el-breadcrumb>
    </div>
    <div class="main">
      <deviceList :parentDeviceId="parentDeviceId" />
    </div>
  </div>
  <el-drawer
    title="编辑"
    :visible.sync="isShowDrawer"
    size="480px"
    @close="isShowDrawer = false">
    <el-form
      :model="dataDetail"
      :rules="rules"
      ref="ruleForm"
      class="demo-ruleForm"
      label-width="100px">
      <el-form-item label="设备名称" prop="deviceName">
        <el-input v-model="dataDetail.deviceName"></el-input>
      </el-form-item>
      <el-form-item label="设备编码" prop="deviceCode">
        <el-input v-model="dataDetail.deviceCode"></el-input>
      </el-form-item>
    </el-form>
    <div class="drawerFoot">
      <el-button type="info" plain @click="isShowDrawer = false">取消</el-button>
      <el-button type="primary" plain @click="confirmHandle" :loading="loading">{{loading ? '提交中' : '提交'}}</el-button>
    </div>
  </el-drawer>
</div>
</template>

<script>
import TabBlock from '@/components/common/TabBlock'
import deviceList from '@/views/deviceManagement/deviceDetails/deviceList'
import BasicInfo from '@/views/deviceManagement/deviceDetails/BasicInfo'
import DeviceDatas from '@/views/deviceManagement/deviceDetails/DeviceDatas'
import IssueCommand from '@/views/deviceManagement/deviceDetails/IssueCommand'
import AlarmRecord from '@/views/deviceManagement/deviceDetails/AlarmRecord'
import FaultRecord from '@/views/deviceManagement/deviceDetails/FaultRecord'
import InstallRecord from '@/views/deviceManagement/deviceDetails/InstallRecord'
// import DeviceRightCons from '@/views/deviceManagement/deviceDetails/DeviceRightCons'
import DeviceRightCons from '@/views/deviceManagement/gatewayChild/DeviceRightCons'
import CardOne from '@/components/common/CardOne'
export default {
  name:'DeviceGas',
  components: {
    deviceList,
    TabBlock,
    BasicInfo,
    DeviceDatas,
    IssueCommand,
    AlarmRecord,
    FaultRecord,
    InstallRecord,
    CardOne,
    DeviceRightCons
  },
  data() {
    return {
      isShowDrawer: false,
      treeData: [],
      searchText: '',
      keyWords: {
        isAlarm: "",
        isFault: "",
        isInstall: "",
        isOnline: "",
        isRegist: "",
        typeId: ''
      },
      options: [
        { value: '1', label: '在线' },
        { value: '0', label: '离线' }
      ],
      component: '',
      tabs: [
        { name: '基本信息', code: 'BasicInfo' },
        { name: '设备数据', code: 'DeviceDatas' }, 
        // { name: '下发命令', code: 'IssueCommand' },
        { name: '报警记录', code: 'AlarmRecord' },
        { name: '故障记录', code: 'FaultRecord' },
        { name: '安装记录', code: 'InstallRecord' }
      ],
      pageType: 'DeviceGas',
      styleObject: {
        height: ''
      },
      styleObjectCons: {
        height: ''
      },
      tabData: {},
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 12,
        pageSizes: [12,22,32],
        total: 0
      },
      dataList: [],
      deviceTypeList: [],
      fields:[],
      tableLoading: true,
      loading: false,
      deviceId: null,
      getEchartStatus: '',
      deviceImei: '',
      changeStatus: false,
      consShow: false,
      currentTreeId: '',
      showSlid: false,
      isMobile: false, // 是否是终端设备
      props: {
        label: 'label',
        children: 'children',
        isLeaf: 'isLeaf'
      },
      parentDeviceId: '',
      dataDetail: {
        deviceName: '',
        deviceCode: '',
      },
      rules: {
        deviceName: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        deviceCode: [{ required: true, message: '请输入设备编码', trigger: 'blur' }],
      },
    }
  },
  created() {
    this.makeheight()
    this.makeheightCons()
    // this.queryTreeNode()
    // this.initData()
    this.getDeviceType()
  },
  methods: {
    // 显示设备列表
    handleList (id) {
      this.parentDeviceId = id
      this.tabData = {
        name: '设备列表',
        code: 'BasicInfo',
      }
    },
    handleEditClick ({ name, imei, deviceId }) {
      this.isShowDrawer = true
      this.deviceId = deviceId
      this.dataDetail = { deviceName: name, deviceCode: imei }
    },
    showLabel(label) {
      if (!label) {
        return label;
      }
      return label;
    },
    // // 查询组织
    // queryTreeNode(pid = 0) {
    //   this.request.get(`/front/system/organization/findTreeById?id=${pid}`)
    //     .then(rs => {
    //       // console.log(rs);
    //       this.treeData = rs.code === 200 ? rs.data : [];
    //       this.currentTreeId = this.treeData.length > 0 ? this.treeData[0].value : 0;
    //     })
    //     .catch(error => (this.treeData = []));
    // },
    // 查询区域
    queryTreeNode (pid = 0) {
      let isMaxTenant = this.storage.getSession("isMaxTenant")
      this.request.get(`/front/device/region/findTreeById?id=${pid}`)
        .then(rs => {
          this.treeData = rs.code === 200 ? rs.data : [];
          if (isMaxTenant == 0) {
            this.treeData.push({
              children: [],
              id: -1,
              label: "终端出库设备",
              parentId: 0,
              serial: 51,
              tenantId: null,
              terminalFlag: null,
              value: -1
            })
          }
          this.currentTreeId = this.treeData.length > 0 ? (this.treeData[0].value?this.treeData[0].value:0):0;
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.treeData[0].value)
          })
          this.initData()
        })
        .catch(error => (this.treeData = []));
    },
    // 查询区域
    loadData (node, resolve) {
      // let isMaxTenant = this.storage.getSession("isMaxTenant")
      if (node.level === 0) {
        let root = { id: 0, label: '区域机构', parentId: 0, value: 0 }
        
        //默认展开第一层根节点---节点渲染完成后，加载第二层节点的核心代码
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(0)
          let nodedata = node.childNodes[0];
          nodedata.expanded = true;
          nodedata.loadData();
        })
        resolve([root])
      } else {
        let pid = node.data ? node.data.id : 0

        this.request.get(`/front/device/region/findTreefenjiById?id=${pid}`).then(rs => {
          let data = rs.code === 200 ? rs.data : []

          // if (isMaxTenant == 0) {
          //   data.push({
          //     id: -1,
          //     label: "终端出库设备",
          //     parentId: 0,
          //     value: -1,
          //     isLeaf: true
          //   })
          // }
          // 区域-终端出库设备
          if (node.level == 1) {
            data.unshift({ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true })
          }

          this.initData()
          resolve(data)
          
        }).catch(error => {
          console.error(error)
          let temp = node.level == 1 ? [{ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true }] : []
          resolve(temp)
        })        
      }
    },
    // 节点点击发生变化时，触发事件
    handleNodeSelect(item) {
      this.isMobile = item.id == -1
      this.currentTreeId = item ? (item.value ? item.value : 0) : 0;
      this.pagination.currentPage = 1;
      this.initData();
    },
    getDeviceType() {
      this.request.post('/front/device/type/query', {
        page: 1,
        pageSize: 1000
      }).then(res => {
        // console.log(res);
        if (res.code === 200) {
          this.deviceTypeList = res.data.data?res.data.data:[]
        } else if (res.code === 500) {
          this.deviceTypeList = []
          this.msg.warn(res.msg)
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    serachData() {
      //查询//搜索
      this.getEchartStatus = this.keyWords.typeId
      this.searchText = this.searchText.replace(/(^\s*)|(\s*$)/g, "")
      this.pagination.currentPage = 1
      this.initData()
    },
    initData() {
      this.consShow=false
      this.params = {
        key: this.searchText,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        orgId: this.currentTreeId?this.currentTreeId:0,
        typeId: this.keyWords.typeId,
        isInstall: this.keyWords.isInstall,
        isAlarm: this.keyWords.isAlarm,
        isFault: this.keyWords.isFault,
        isRegist: this.keyWords.isRegist,
        isOnline: this.keyWords.isOnline,
      }
      let url = this.params.orgId == -1 ? '/front/device/transmission/queryOutbound' : '/front/device/transmission/query'
      this.request.get(url, this.params)
        .then(res => {
          if (res.code === 200) {
            this.tableLoading = false
            this.consShow = true
            let dataList = res.data ? res.data : []
            this.dataList = dataList
            this.pagination.total = res.total
          } else if (res.code === 500) {
            this.dataList = []
            this.msg.warn(res.msg)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 提交修改
    async confirmHandle () {
      let deviceId = this.deviceId
      let { deviceName, deviceCode } = this.dataDetail
      this.loading = true
      let { code, msg } = await this.request.get('/front/device/transmission/edit', { name: deviceName, imei: deviceCode, deviceId })
      this.loading = false

      if (code == 200) {
        this.isShowDrawer = false
        this.initData()
        this.$message({ type: 'success', message: '提交成功！' })
      } else {
        this.$message({ type: 'warning', message: msg })
      }
    },
    jumpDev() {
      this.tabData = {}
      this.initData()
    },
    toggleCom(tabCode) {
      // console.log(tabCode);
      this.tabData = tabCode
      this.component = tabCode.code
    },
    clickEven(val) {
      // console.log(this.isMobile);
      this.tabData = {
        name: '基本信息',
        code: 'BasicInfo'
      }
      this.deviceId = val.deviceId
      this.deviceImei = val.imei
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和makeheightCons
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    makeheightCons(height = 205) {
      let _this = this;
      _this.styleObjectCons.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObjectCons.height = window.innerHeight - height + "px";
        })();
      };
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.initData()
    },
    handleSizeChange(val) {
      this.pagination.currentPage =1
      this.pagination.pageSize = val
      this.initData()
    },
    changeRightCons(){
      if(!this.changeStatus){
        this.changeStatus = true
        this.showSlid = true
      } else {
        this.showSlid = false
        setTimeout(() => {
          this.changeStatus = this.showSlid
        }, 440)
      }
    },
    closeRightCons(data){
      this.showSlid = false
        setTimeout(() => {
          this.changeStatus = data
        }, 440)
    },
  }
};
</script>
<!--  -->
<style lang="scss" scoped>
.DeviceListsGas {
  position: relative;
  .devcieContainer {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
    h4 {
      padding-bottom: 10px;
    }
    .container {
      padding-left: 260px;
    }
    .query {
      padding-bottom: 10px;
      .queryCons{
        width: 100%;
        overflow: hidden;
        .common{
          float: left;
          margin-bottom: 5px;
        }
        .primaryBtn {
          width: 82px;
          height: 36px;
          cursor: pointer;
          margin-right: 20px;
          font-size: 14px;
          line-height: 36px;
          border: 0;
          color: #FFFFFF;
          background: #1089FF;
          border-radius: 2px;
          &:hover {
            background: #0774e0;
          }
        }
        .delSome{
          // width: 102px;
          // cursor: pointer;
          float: right;
          // font-size: 0;
          // padding: 0 10px;
          // border: 0;
          // color: #FFFFFF;
          // background: #1089FF;
          // border-radius: 2px;
          // outline: unset;
          // overflow: hidden;
          // &:hover{
          //   background: #0774e0;
          // }
          // .imgShow{
          //   float: left;
          //   width: 16px;
          //   height: 16px;
          //   margin:10px 6px 0 0;
          //   img{
          //     width: 100%;
          //     height: 100%;
          //     vertical-align: middle;
          //   }
          //   &.active{
          //     transform: rotate(180deg);
          //   }
          // }
          // span{
          //   float: left;
          //   font-size: 14px;
          //   line-height: 36px;
          // }
        }
      }
    }
    .listsContainer {
      overflow: hidden;
      position: relative;
      .listsLeft {
        float: left;
        width: 100%;
        height: 100%;
        box-sizing:border-box;
        padding: 0 0 60px;
        position: relative;
        background: #f2f2f2;
        .noData{
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -150px;
          margin-top: -150px;
          text-align: center;
          img{
            width: 300px;
            height: 300px;
          }
          .tip{
            margin-top: 10px;
            font-size: 18px;
            color: #bbb;
          }
        }
        .cardList{
          width: 100%;
          height: 100%;

          &>li {
            float: left;
            width: 300px;
            height: 215px;
            padding: 10px 15px;
            margin-left: 20px;
            box-sizing: border-box;
            position: relative;
            border-top: 3px #08BB80 solid;
            margin-top: 20px;
            background-color: #fff;
            cursor: pointer;
            color: #7C7C7C;
            h4 {
              height: 28px;
              line-height: 28px;
              color: #333;
              font-weight: bold;
              font-size: 16px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              padding-bottom: 4px;
              i {
                position: absolute;
                top: 14px;
                right: 15px;
                font-size: 22px;
                color: #178FFD;
              }
            }
            >p {
              // color: #c7cdcd;
              line-height: 26px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .status {
              span {
                display: inline-block;
                width: 80px;
                height: 26px;
                line-height: 26px;
                border-radius: 13px;
                text-align: center;
                overflow: hidden;
                background: #E7F3FF;
                color: #1089FF;
                &::before {
                  content: '';
                  width: 5px;
                  height: 5px;
                  vertical-align: 2px;
                  background-color: #1089FF;
                  border-radius: 50%;
                  margin-right: 8px;
                  display: inline-block;
                }
              }
            }
            &.active {
              color: #b8babc;
              border-top-color: #999B9E;
              h4 {
                color: #999b9e;
              }
              .status {
                span {
                  background: #EEEFEF;
                  color: #999B9E;
                  &::before {
                    background-color: #999B9E;
                  }
                }
              }
            }
            &.active1 {
              color: #f43300;
              border-top-color: #f43300;
              h4 {
                color: #f43300;
              }
              .status {
                span {
                  background: #fdeae5;
                  color: #f43300;
                  &::before {
                    background-color: #f43300;
                  }
                }
              }
            }
            &.active2 {
              color: #ED9617;
              border-top-color: #ED9617;
              h4 {
                color: #ED9617;
              }
              .status {
                span {
                  background: #FDF4E7;
                  color: #ED9617;
                  &::before {
                    background-color: #ED9617;
                  }
                }
              }
            }
            &.active3 {
              color: #7C7C7C;
              border-top-color: #08BB80;
              h4 {
                color: #333;
              }
              .status {
                span {
                  background: #E7F3FF;
                  color: #1089FF;
                  &::before {
                    background-color: #1089FF;
                  }
                }
              }
            }
          }
        }
        .cardPage {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 50px;
          text-align: center;
          padding: 10px 0;
          box-sizing: border-box;
        }
      } 
    }
  }
  .maskingRight {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0,0.4);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    .listsRight {
      position: absolute;
      right: 12px;
      top: 0;
      width: 740px;
      height: 100%;
      z-index: 9999;
      box-shadow: -2px 0 10px #ccc;
      background: #fff;

      &.component-slid-open {
        position: absolute;
        top: 0;
        right: 0;
        width: 740px;
        height: 100%;
        background: #fff;
        opacity: 1;
        animation: slid-open 0.5s ease;
      }

      &.component-slid-out {
        position: absolute;
        top: 0;
        right: 0;
        width: 740px;
        height: 100%;
        background: #fff;
        animation: slid-out 0.5s ease;
      }

      .messContainer {
        width: 100%;
        height: 100%;
        // padding-left: 10px;
        box-sizing: border-box;

        .cons {
          width: 100%;
          height: 100%;
          // background: #f3f3f3;
          // background: rgba(243,243,243,1);
        }
      }
    }
  }
  .mainContent{
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
    .main {
      height: calc(100% - 55px);
    }
  }
  @keyframes slid-open{
    0%{
      transform: translateX(100%);
      opacity: 0;
    }
    100%{
      transform: translateX(0);
    }
  }
  @keyframes slid-out{
    0%{
      width: 600px;
      transform: translateX(0)
    }
    100%{
      transform: translateX(100%)
    }
  }
}
</style><style lang="scss">
.DeviceListsGas {
  .devcieContainer {
    .query {
      .el-input {
        width: 180px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }

      .el-select {
        width: 110px;
        margin-right: 10px;

        .el-input {
          width: 110px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 36px;
            height: 36px;
          }
        }
      }
    }
    .el-loading-mask{
      background-color: unset;
    }
    .treeAside {
      position: absolute;
      width: 300px;
      height: 100%;
      padding: 15px 20px;
      left: 0;
      top: 0;
      box-sizing: border-box;

      .treeTop {
        position: absolute;
        height: 40px;
        line-height: 40px;
        font-size: 0;
        font-weight: bold;
        top: 20px;
        z-index: 10;
        // left: 30px;
        padding-left: 10px;

        .treeTopTitle {
          margin-right: 115px;
          // width: 500px;
          font-size: 18px;
          color: #333;
        }

        .el-button {
          margin-left: -24px;
        }

        .complete {
          margin-left: 10px;
        }
      }

      .treeBox {
        overflow: hidden;
        height: 100%;
        border: 1px solid #ebeef5;
        padding: 40px 0 10px;
        box-sizing: border-box;
      }

      .tree {
        height: 100%;
        overflow: auto;

        .el-tree-node__content {
          height: 40px;
        }

        .custom-tree-node {
          height: 40px;
          line-height: 40px;
          width: 100%;

          .treeLabel {
            font-size: 14px;
            display: inline-block;
            width: 130px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .treeBtn {
            float: right;

            .el-button {
              margin-left: 0;
            }
          }
        }
      }
    }
  }
  .mainContent{
    .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{
      color: #7A7D81;
      font-size: 16px;
      font-weight: 500;
    }
    .el-breadcrumb__separator{
      font-size: 16px;
      color: #7A7D81;
      margin: 0 5px;
      font-weight: 500;
    }
    .el-breadcrumb__inner{
      font-size: 16px;
      color: #7A7D81 !important;
      font-weight: 500 !important;
    }
  }
  .demo-ruleForm {
    width: 80%;
    margin: 50px auto;
  }
  .drawerFoot {
    border-top: 1px solid #D7DAE2;
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 70px;
    line-height: 70px;
    text-align: right;
    padding-right: 30px;
    box-sizing: border-box;
    box-shadow: 4px 0 4px 2px rgba(144,147,153,.2);
  }
}
</style>
